<ng-container
    *ngIf="{
        initData: initData$ | async,
        verification: verification$ | async
    } as data">
    <app-purchase [dwollaSupport]="dwollaSupport">
        <app-purchase-details
            *ngIf="currentTab === 0"
            target="purchase-details"
            [verification]="data.verification"
            [initData]="data.initData"></app-purchase-details>

        <app-purchase-details-recurring
            *ngIf="currentTab === 1"
            target="purchase-details-recurring"
            [verification]="data.verification"
            [initData]="data.initData"></app-purchase-details-recurring>

        <app-purchase-agreement
            *ngIf="currentTab === 2"
            target="purchase-agreement"></app-purchase-agreement>

        <app-purchase-payment
            *ngIf="currentTab === 3"
            target="purchase-payment"
            [initData]="data.initData"></app-purchase-payment>
    </app-purchase>
</ng-container>
